module.exports = __webpack_public_path__ + "media/svg/ic-warning-15e29901.svg";